import { TableHead, TableRow, TableHeaderCell } from "@/components/atoms/Table";
import { DashboardTableHeaderProps } from "./Dashboardtable.types";

export const DashboardTableHeader = ({ headers }: DashboardTableHeaderProps) => (
    <TableHead className="bg-primary-500 text-white">
        <TableRow>
            {headers?.map((it, i) => (
                <TableHeaderCell key={i}>{it}</TableHeaderCell>
            ))}
        </TableRow>
    </TableHead>
);
